import { User } from '../../services/redux/authSlice';
import { hasAnyPermissions } from '../functions/utils';

export function hasAnyFinancingTabPermission(user: User | undefined) {
  return hasAnyPermissions(user, [
    'financing_factoring_receive',
    'financing_creditLine_receive',
    'financing_fundSale_view',
    'financing_extension_view',
    'financing_payment_request_passive_read',
  ]);
}

export function hasAnyPaymentPermission(user: User | undefined) {
  return hasAnyPermissions(user, [
    'financing_payout_view',
    'financing_payIn_view',
    'financing_discount_view',
    'financing_fnc_view',
  ]);
}

export function hasAnyCollectionsPermission(user: User | undefined) {
  return hasAnyPermissions(user, [
    'collections_view',
    'financing_verification_view',
  ]);
}

export function hasAnyReportingPermission(user: User | undefined) {
  return hasAnyPermissions(user, [
    'reporting_active_wallet_read',
    'reporting_active_history_read',
    'reporting_transact_book_read',
    'reporting_income_book_read',
    'reporting_alerts_read',
    'reporting_invoicing_book_read',
  ]);
}

export function hasAnyAccountingPermission(user: User | undefined) {
  return hasAnyPermissions(user, [
    'accounting_read_all',
    'accounting_write_entries',
    'accounting_delete_entries',
  ]);
}

export const hasAnyFinancingPermission = (user: any) => {
  return (
    hasAnyFinancingTabPermission(user) ||
    hasAnyPaymentPermission(user) ||
    hasAnyCollectionsPermission(user) ||
    hasAnyReportingPermission(user) ||
    hasAnyAccountingPermission(user)
  );
};
